import { on, removeListener } from "api/prokey/prokey.websocket";
import React, { createContext, useEffect, useState } from "react"

const TaskContext = createContext()

//-----------------------------------------------------------------
function TaskProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [ task      , setTask      ] = useState( {} );
  const [ documents , setDocuments ] = useState( {} );
  const [ blocks    , setBlocks    ] = useState( {} );
  const [ fields    , setFields    ] = useState( {} );
  const [ images    , setImages    ] = useState( {} );

  const values = {
    images ,
  };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleImage(data) {
      //-----------------------------------------------------------------
      if( images.hasOwnProperty( data?.id ) ) return;

      const temp = document.createElement('img');
      
      temp.onload = function() {
        const images_new = { ...images };
        data.html_image = temp;
        images_new[data.id] = data;
        setImages( images_new );
      };
      
      temp.onError = function() {
      }

      temp.src = data?.url;
    }

    on( 'IMAGE', handleImage );

    return () => {
      removeListener( 'IMAGE' , handleImage );
    };
  }, [images] );

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleTask(data) {
      //-----------------------------------------------------------------
      if( data?.id === task.id ) return;

      setTask( data );
      setImages({});
    }

    on( 'TASK_INFO', handleTask );

    return () => {
      removeListener( 'TASK_INFO' , handleTask );
    };
  }, [] )

  //#endregion

  return (
    <TaskContext.Provider value={ values }>
      {children}
    </TaskContext.Provider>
  );
};

export { TaskContext, TaskProvider };